import flatten from 'lodash/flatten';
import uniqBy from 'lodash/uniqBy';

export function getInitialInviteeEmails({ workspaces = [], currentUserEmail }) {
  const inviteeAttendees = flatten(
    workspaces.map(({ teammateEmail, attendees }) => (attendees?.length ? attendees : [{ email: teammateEmail }]))
  );

  const selectedEmails = flatten(workspaces.map(({ emails, email }) => emails || email));
  // Not very clean but this assumes that we are in the invite teammates step for the first time
  // if every email is equal to undefined
  const firstTimeInStep = selectedEmails.length && selectedEmails.every(email => email === undefined);

  return uniqBy(
    inviteeAttendees.filter(({ email }) => email && email !== currentUserEmail),
    'email'
  ).map(({ email }) => ({
    email,
    selected: firstTimeInStep || selectedEmails.includes(email),
  }));
}

export function outputWorkspacesDecorator({ workspaces, inviteeEmails, personalMessage }) {
  return workspaces.map(workspace =>
    workspace.recurring_meeting_uuid
      ? {
          ...workspace,
          emails: workspace?.attendees.filter(({ email }) => inviteeEmails.includes(email))?.map(({ email }) => email),
          personalMessage,
        }
      : {
          ...workspace,
          email: inviteeEmails.includes(workspace.teammateEmail) ? workspace.teammateEmail : null,
          personalMessage,
        }
  );
}
